import React from 'react';
import SVGLoader from './SVGLoader';

const defaults = {
  viewboxHeight: 12,
  viewboxWidth: 12,
};

export default ({
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  ...rest
}) => (
  <SVGLoader
    viewboxHeight={viewboxHeight}
    viewboxWidth={viewboxWidth}
    {...rest}
  >
    <g clipPath="url(#clip0_106_11485)">
      <mask
        id="mask0_106_11485"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="12"
        height="12"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 0H0V12H0.887341C0.782913 11.9561 0.685083 11.8916 0.600039 11.8066L11.2066 1.2L11.843 1.8364L1.87283 11.8066C1.78779 11.8916 1.68996 11.9561 1.58553 12H12V0Z"
          fill="currentColor"
        />
      </mask>
      <g mask="url(#mask0_106_11485)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.58947 7.33953C7.1678 7.7612 6.59627 7.99868 5.99994 8C5.51864 7.99893 5.05351 7.84404 4.67027 7.56262L8.24994 3.98672V5.75C8.24862 6.34633 8.01114 6.91786 7.58947 7.33953ZM4.41041 7.33953L8.24994 3.55547V2.25C8.24994 1.65326 8.01289 1.08097 7.59093 0.65901C7.16897 0.237053 6.59668 0 5.99994 0C5.4032 0 4.83091 0.237053 4.40895 0.65901C3.98699 1.08097 3.74994 1.65326 3.74994 2.25V5.75C3.75126 6.34633 3.98874 6.91786 4.41041 7.33953Z"
          fill="currentColor"
        />
        <path
          d="M8.24994 3.55547L4.41041 7.33953C4.49175 7.42087 4.57867 7.49536 4.67027 7.56262L8.24994 3.98672V3.55547Z"
          fill="currentColor"
        />
        <path
          d="M9.49994 4C9.36733 4 9.24015 4.05268 9.14639 4.14645C9.05262 4.24021 8.99994 4.36739 8.99994 4.5V5.75C8.99994 6.54565 8.68387 7.30871 8.12126 7.87132C7.55865 8.43393 6.79559 8.75 5.99994 8.75C5.20429 8.75 4.44123 8.43393 3.87862 7.87132C3.31601 7.30871 2.99994 6.54565 2.99994 5.75V4.5C2.99994 4.36739 2.94726 4.24021 2.85349 4.14645C2.75972 4.05268 2.63255 4 2.49994 4C2.36733 4 2.24015 4.05268 2.14639 4.14645C2.05262 4.24021 1.99994 4.36739 1.99994 4.5V5.75C1.9997 6.7062 2.342 7.63085 2.96481 8.35639C3.58762 9.08194 4.44974 9.56037 5.39494 9.705C5.42368 9.70965 5.44989 9.72418 5.46906 9.74608C5.48823 9.76799 5.49915 9.7959 5.49994 9.825V11.5C5.49994 11.6326 5.55262 11.7598 5.64639 11.8536C5.74015 11.9473 5.86733 12 5.99994 12C6.13255 12 6.25972 11.9473 6.35349 11.8536C6.44726 11.7598 6.49994 11.6326 6.49994 11.5V9.825C6.50073 9.7959 6.51165 9.76799 6.53082 9.74608C6.54999 9.72418 6.5762 9.70965 6.60494 9.705C7.55014 9.56037 8.41225 9.08194 9.03507 8.35639C9.65788 7.63085 10.0002 6.7062 9.99994 5.75V4.5C9.99994 4.36739 9.94726 4.24021 9.85349 4.14645C9.75972 4.05268 9.63255 4 9.49994 4Z"
          fill="currentColor"
        />
      </g>
      <path
        d="M10.8135 0.39321C10.9892 0.217474 11.2741 0.217474 11.4499 0.39321C11.6256 0.568946 11.6256 0.85387 11.4499 1.02961L1.05538 11.4241C0.879645 11.5998 0.594722 11.5998 0.418986 11.4241C0.24325 11.2483 0.24325 10.9634 0.418986 10.7877L10.8135 0.39321Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_106_11485">
        <rect width="12" height="12" fill="currentColor" />
      </clipPath>
    </defs>
  </SVGLoader>
);
